import { configPromise } from "../../config/configMiddleware";
import { postWith, deleteWith, patchWith } from "../axios";

export async function createMarket(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/marketV2/`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateMarket(id: string, data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/marketV2/${id}`;
    return (await patchWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function hardDeleteMarket(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/marketV2/hard-delete/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}
